import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import NotificationsService from 'src/_services/NotificationsService';
import { API_LOADING_STATUSES } from 'src/constants';
import { forEach } from 'lodash';

const initialState = {
    notifications: [],
    paginationData: {},
    unreadCount: 0,
    status: API_LOADING_STATUSES.idle,
    hasNextPage: false,
    error: null,
    notificationLoading: false
    //     docs,
    //     totalDocs,
    //     limit,
    //     totalPages,
    //     page,
    //     pagingCounter,
    //     hasPrevPage,
    //     hasNextPage,
    //     prevPage,
    //     nextPage,
    //     unreadCount
}

export const fetchNotifications = createAsyncThunk('notifications/fetchNotifications', async ({page=1, limit=20}, ) => {
    const response = await NotificationsService.getNotifications(page, limit);
    return response.data.body
})

export const setNotificationSeen = createAsyncThunk('notifications/setNotificationSeen', async id => {
    await NotificationsService.setNotificationSeen(id);
    return { id };
})

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        notificationReceived: {
            reducer(state, action) {
                state.notifications.unshift(action.payload);
                state.unreadCount = state.unreadCount + 1;
                state.paginationData = {
                    ...state.paginationData,
                    totalDocs: state.paginationData.totalDocs + 1
                }
                // state.notifications.push(action.payload)
            }
        },
        clearNotifications: (state)=>{
            state.notifications = []
            state.hasNextPage = false
            state.notificationLoading = false
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchNotifications.pending, (state, action) => {
                state.status = API_LOADING_STATUSES.loading
                state.notificationLoading = true
            })
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                const { notifications, unreadCount } = action.payload;
                const { docs, ...paginationData } = notifications
                state.notifications = docs;
                state.hasNextPage = paginationData.hasNextPage
                state.paginationData = paginationData
                state.unreadCount = unreadCount;
                state.status = API_LOADING_STATUSES.succeeded
                state.notificationLoading = false
            })
            .addCase(fetchNotifications.rejected, (state, action) => {
                state.status = API_LOADING_STATUSES.failed
                state.error = action.error.message
                state.notificationLoading = false
            })
            .addCase(setNotificationSeen.fulfilled, (state, action) => {
                if(!action.payload.id){
                    state.unreadCount = 0
                }
                forEach(state.notifications, notification => {
                    if (notification.id === action.payload.id) {
                        notification.read = true;
                    }
                })
            })
    }
})

export const { notificationReceived, clearNotifications } = notificationsSlice.actions

export default notificationsSlice.reducer
